import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cancellation',
    templateUrl: './cancellation.component.html',
    styleUrls: ['./cancellation.component.scss'],
    standalone: false
})
export class CancellationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
